import script from "./AllConferencesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AllConferencesPage.vue?vue&type=script&setup=true&lang=js"

import "./AllConferencesPage.vue?vue&type=style&index=0&id=4680e3a7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4680e3a7"]])

export default __exports__